export const useDebtToIncomeTruv = () => {
  const styles = {
    containerTruv: {
      mt: 4,
    },
  };
  return { styles };
};
